import {
  AdType,
  DailyBudgetPlan,
  DeliverType,
  RtbCampaignPlanType,
  RtbOptimize,
} from 'core/rtbCampaign/RtbCampaign';
import {
  DefaultRtbCampaignBasicFormModel,
  RtbCampaignBasicFormModel,
} from './RtbCampaignBasicFormModel';
import { OPERATE } from 'enum/Operate';
import { L1ObjectObjective } from 'core/l1Object/L1Object';
import { L2ObjectOptimizationGoal } from 'core/l2Object/L2Object';
import { omitBy, isEmpty } from 'lodash';
import { RtbCampaignSetupFlowPageModel } from '../RtbCampaignSetupFlowPageModel';

export interface ShopFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}
abstract class AbstractShopFormModel
  extends DefaultRtbCampaignBasicFormModel
  implements ShopFormModel
{
  constructor(
    mode: 'create' | 'edit',
    flowModel: RtbCampaignSetupFlowPageModel,
  ) {
    super(mode, flowModel);
    this.defaultDeliverType = DeliverType.ACCELERATED;
  }

  async init() {}
  // 定義素材類型
  get campaignAdType(): AdType {
    return AdType.SHOP;
  }
  // 可否設定人口屬性
  get needSetupAgeGender(): boolean {
    return false;
  }
  // 可否設定投遞速率
  get showDeliverType(): boolean {
    return false;
  }
  // 可否設定最佳化與投遞
  get showOptimizeSection(): boolean {
    return false;
  }
  // 定向初始化設定
  get limitationOperates(): {
    need: string[];
    notNeed?: string[];
    other?: string[];
  } {
    return {
      need: [OPERATE.INCLUDE],
      notNeed: undefined,
      other: undefined,
    };
  }

  getRtbOptionsMap() {
    const optionsMap = super.getRtbOptionsMap();
    return omitBy(
      {
        ...optionsMap,
        [L1ObjectObjective.TRAFFIC]: {
          [RtbCampaignPlanType.RS_CPC]: [L2ObjectOptimizationGoal.CLICKS],
        },
      },
      isEmpty,
    );
  }

  setupDefaultCampaign(campaign: any) {
    super.setupDefaultCampaign(campaign);
    campaign.dailyTargetBudget = 0;
  }

  getBidPriceRange(optimize: RtbOptimize): {
    max?: number;
    min: number;
    recommend?: {
      min: number;
      max: number;
    };
  } {
    return {
      max: this.getBidCap(optimize),
      min: this.getBidFloor(optimize),
      recommend: {
        min: 10,
        max: 20,
      },
    };
  }
}

export class EditShopFormModel extends AbstractShopFormModel {
  constructor(flowModel: RtbCampaignSetupFlowPageModel) {
    super('edit', flowModel);
  }
  get canEditBudgetPlan(): boolean {
    return false;
  }
  get canEditPriceModel(): boolean {
    return false;
  }
}

export class CreateShopFormModel extends AbstractShopFormModel {
  constructor(flowModel: RtbCampaignSetupFlowPageModel) {
    super('create', flowModel);
    this.modelDailyBudgetType = DailyBudgetPlan.DAILY;
  }
  get canEditBudgetPlan(): boolean {
    return true;
  }
  get canEditPriceModel(): boolean {
    return true;
  }
}
